import 'Styles/templates/article.scss'
import axios from 'axios'
import $ from 'cash-dom'
import { findSubstrings } from '../utils'

const ISO_STORES = [
  'en-gb',
  'en-ca',
  'en-au',
  'en-de',
  'en-sg',
  'en-int',
  'en-in',
  'en-ch',
]

const endpoint =
  'https://teddy-baldassarre-watches.myshopify.com/api/2025-01/graphql.json'
const token = '0172fb0ba8e0fc0685f8dc8a458ff088'
const headers = { 'X-Shopify-Storefront-Access-Token': token }

$(() => {
  const articleContent = document.querySelector('#articleContent')
  const articleHandle = articleContent.dataset.articleHandle.split('/')[1]

  const headerUtm = `?utm_term=Header_Link&utm_content=Blog_Article_${articleHandle}`
  const headerAnchors = Array.from(document.querySelectorAll('.site-header a'))
  for (const anchor of headerAnchors) {
    anchor.href = anchor.href + headerUtm
  }

  const sidelinksUtm = `?utm_term=Top_Sidebar&utm_content=Blog_Article_${articleHandle}`
  const affirmSideLinks = Array.from(
    document.querySelectorAll(
      '.affirm-callout__content .affirm-callout__text a'
    )
  )
  const articleCardLinks = Array.from(
    document.querySelectorAll('.article__sidebar .article-card a')
  )

  affirmSideLinks.forEach((a) => {
    a.href = a.href + sidelinksUtm
  })

  articleCardLinks.forEach((a) => {
    a.href = a.href + sidelinksUtm
  })

  const footerLinks = Array.from(
    document.querySelectorAll('.footer.section-pad .grid.grid-cols-1.gap-y-1 a')
  )
  const footerUtm = `?utm_term=Footer_Link&utm_content=Blog_Article_${articleHandle}`

  footerLinks.forEach((a) => {
    a.href = a.href + footerUtm
  })

  const $els = {
    fbShare: $('.fb-share'),
    twShare: $('.tw-share'),
  }
  const rawUrl = window.location.href
  const fmtUrl = rawUrl.endsWith('/') ? rawUrl.replace(/\/$/, '') : rawUrl
  const url = encodeURIComponent(fmtUrl)
  const title = encodeURIComponent(window.document.title)
  const launchNewWindow = (link) => {
    const top = window.innerHeight / 2
    const left = window.innerWidth / 1.75
    window.open(
      link,
      '',
      `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600,top=${top},left=${left}`
    )
  }
  $els.fbShare.on('click', () => {
    const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`
    launchNewWindow(fbUrl)
  })
  $els.twShare.on('click', () => {
    const twUrl = `https://twitter.com/intent/tweet?url=${url}%2F&text=${title}`
    launchNewWindow(twUrl)
  })

  const arr = []
  arr.slice
    .call(document.querySelectorAll('article iframe'))
    .forEach((iframe) => {
      iframe.parentElement.classList.add('iframe-wrapper')
    })

  document.querySelectorAll('.in-article-collection').forEach(async (coll) => {
    const handle = coll.dataset.collection
    const query = `{
      collectionByHandle(handle: "${handle}") {
        title
        onlineStoreUrl
        metafields(identifiers: [{ key: "in_article_upsell_image", namespace: "accentuate" }, { key: "in_article_upsell_title", namespace: "accentuate" }]) {
          key
          value
        }
      }
    }`
    const { data } = await axios.post(endpoint, { query }, { headers })
    const collection = data.data.collectionByHandle
    const metafields = collection.metafields
    const imageMeta = metafields.find(
      (m) => m.key === 'in_article_upsell_image'
    )
    const titleMeta = metafields.find(
      (m) => m.key === 'in_article_upsell_title'
    )
    const image = JSON.parse(imageMeta.value)[0]
    const title = titleMeta.value || collection.title

    const store = findSubstrings(ISO_STORES, window.location.href)[0]
    const urlWithStore = `${
      store ? '/' + store : ''
    }/collections/${handle}?utm_term=instream_Ads&utm_content=Blog_Article_${articleHandle}`

    const html = `
      <div class="in-article-collection__content">
        <div class="in-article-collection__image">
          <img src="${image.src}" loading="lazy" />
        </div>
        <div class="in-article-collection__info">
          <div class="mb-4">
            <span class="h2">${title}</span>
          </div>
          <a class="button button--primary-inverted" href="${urlWithStore}">Shop Now</a>
        </div>
      </div>
    `
    coll.innerHTML = html
  })

  const fetchProduct = async (handle) => {
    const query = `{
      productByHandle(handle: "${handle}") {
        title
        handle
        onlineStoreUrl
        vendor
        featuredImage {
          url
        }
        priceRange {
          minVariantPrice {
            amount
          }
        }
      }
    }`
    const { data } = await axios.post(endpoint, { query }, { headers })
    return data.data.productByHandle
  }

  const formatPrice = (price) => {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(price)
  }

  const smalls = document.querySelectorAll('.in-article-products-small')
  if (!!smalls) {
    smalls.forEach(async (p) => {
      const handles = p.dataset.products.split(',')
      const products = await Promise.all(
        handles.map((handle) => fetchProduct(handle.trim()))
      )
      const limit =
        document.querySelector('.article').dataset.productsSmallLoadLimit
      const states = { init: '', more: '' }

      products.forEach((product, i) => {
        if (!product) return
        const store = findSubstrings(ISO_STORES, window.location.href)[0]
        const utm = `?utm_term=Shop_This_Article&utm_content=Blog_Article_${articleHandle}`
        const urlWithStore = `${store ? '/' + store : ''}/products/${
          product.handle
        }${utm}`

        const price = formatPrice(product.priceRange.minVariantPrice.amount)
        const html = `
          <div class="in-article-product-small">
            <div class="in-article-product-small__content">
              <div class="in-article-product-small__image">
                <img src="${product.featuredImage.url}" loading="lazy" />
              </div>
              <div class="in-article-product-small__info">
                <div class="in-article-product-small__info-inner">
                  <span>${product.vendor}</span>
                  <span class="h4 in-article-product-small__title">${product.title}</span>
                  <span>${price}</span>
                </div>
                <a class="button button--primary" href="${urlWithStore}">View Product</a>
              </div>
            </div>
          </div>
        `
        if (limit) {
          if (i + 1 > limit) {
            states.more = states.more.concat(html)
          } else {
            states.init = states.init.concat(html)
          }
        } else {
          states.init = states.init.concat(html)
        }
      })
      p.innerHTML = states.init
      if (limit && products.length > limit) {
        const loadMore = `
          <div class="load-more-container">
            <button class="in-article-products-small__load-more load-more">Load more +</button>
            <button class="in-article-products-small__show-less show-less">Show less -</button>
          </div>
        `
        p.innerHTML = p.innerHTML + loadMore
        document.addEventListener('click', (e) => {
          if (e.target.matches('.in-article-products-small__load-more')) {
            p.innerHTML = states.init + states.more + loadMore
            const more = document.querySelector(
              '.in-article-products-small__load-more'
            )
            more.style.display = 'none'
            const less = document.querySelector(
              '.in-article-products-small__show-less'
            )
            less.style.display = 'block'
          }
          if (e.target.matches('.in-article-products-small__show-less')) {
            p.innerHTML = states.init + loadMore
            const less = document.querySelector(
              '.in-article-products-small__show-less'
            )
            less.style.display = 'none'
            const more = document.querySelector(
              '.in-article-products-small__load-more'
            )
            more.style.display = 'block'
          }
        })
      } else {
        p.innerHTML = states.init
      }
    })
  }

  document.querySelectorAll('.in-article-product-large').forEach(async (p) => {
    const handle = p.dataset.product
    const product = await fetchProduct(handle)
    const price = formatPrice(product.priceRange.minVariantPrice.amount)
    const store = findSubstrings(ISO_STORES, window.location.href)[0]
    const utm = `?utm_term=Shop_This_Article&utm_content=Blog_Article_${articleHandle}`
    const urlWithStore = `${store ? '/' + store : ''}/products/${handle}${utm}`
    const html = `
      <div class="in-article-product-large__content">
        <div class="in-article-product-large__image">
          <img src="${product.featuredImage.url}" loading="lazy" />
        </div>
        <div class="in-article-product-large__info">
          <span class="subtitle">${product.vendor}</span>
          <div>
            <span class="h3 in-article-product-large__title">${product.title}</span>
            <span class="in-article-product-large__price">${price}</span>
          </div>
          <a class="button button--primary" href="${urlWithStore}">View Product</a>
        </div>
      </div>
    `
    p.innerHTML = html
  })

  document.querySelectorAll('.in-article-shop-now').forEach(async (p) => {
    const handle = p.dataset.product
    const product = await fetchProduct(handle)

    if (product) {
      const price = formatPrice(product.priceRange.minVariantPrice.amount)
      const store = findSubstrings(ISO_STORES, window.location.href)[0]
      const utm = `?utm_term=Shop_Button&utm_content=Blog_Article_${articleHandle}`
      const urlWithStore = `${
        store ? '/' + store : ''
      }/products/${handle}${utm}`

      const html = `
        <div>
          <span class="in-article-shop-now__title">${product.title}</span>
          <span class="in-article-shop-now__price">${price}</span>
        </div>
        <a class="button button--primary" href="${urlWithStore}">Shop now</a>
  
      `
      p.innerHTML = html
    }
  })

  const shopThis = Array.from(document.querySelectorAll('.shop-this-article'))
  if (shopThis) {
    const limit =
      document.querySelector('.article').dataset.shopProductsLoadLimit
    const list = document.querySelector('.shop-this-article-list')
    Promise.all(shopThis.map((st, i) => fetchProduct(st.dataset.product))).then(
      (products) => {
        const states = { init: '', more: '' }
        products.forEach((product, i) => {
          if (!product) return
          const store = findSubstrings(ISO_STORES, window.location.href)[0]
          const utm = `?utm_term=Shop_This_Article&utm_content=Blog_Article_${articleHandle}`
          const urlWithStore = `${store ? '/' + store : ''}/products/${
            product.handle
          }${utm}`

          const price = formatPrice(product.priceRange.minVariantPrice.amount)
          const html = `
            <div class="shop-this-article">
              <div class="shop-this-article__content">
                <div class="shop-this-article__image">
                  <img src="${product.featuredImage.url}" loading="lazy" />
                </div>
                <div class="shop-this-article__info">
                  <span>${product.vendor}</span>
                  <div>
                    <span class="h4 shop-this-article__title">${product.title}</span>
                    <span class="shop-this-article__price">${price}</span>
                  </div>
                  <a class="button button--primary" href="${urlWithStore}">View Product</a>
                </div>
              </div>
            </div>
          `
          if (limit) {
            if (i + 1 > limit) {
              states.more = states.more.concat(html)
            } else {
              states.init = states.init.concat(html)
            }
          } else {
            states.init = states.init.concat(html)
          }
        })
        if (list) {
          list.innerHTML = states.init
        }
        if (limit && products.length > limit) {
          const loadMore = `
            <div class="load-more-container">
              <button class="shop-products__load-more load-more">Load more +</button>
              <button class="shop-products__show-less show-less">Show less -</button>
            </div>
          `
          if (list) {
            list.innerHTML = list.innerHTML + loadMore
            document.addEventListener('click', (e) => {
              if (e.target.matches('.shop-products__load-more')) {
                list.innerHTML = states.init + states.more + loadMore
                const more = document.querySelector('.shop-products__load-more')
                more.style.display = 'none'
                const less = document.querySelector('.shop-products__show-less')
                less.style.display = 'block'
              }
              if (e.target.matches('.shop-products__show-less')) {
                list.innerHTML = states.init + loadMore
                const less = document.querySelector('.shop-products__show-less')
                less.style.display = 'none'
                const more = document.querySelector('.shop-products__load-more')
                more.style.display = 'block'
              }
            })
          }
        } else {
          if (list) {
            list.innerHTML = list.innerHTML
          }
        }
      }
    )
  }
})
